import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'

export const main = css`
  background-color: ${cssTheme.default.day.backgroundInvert};
  position: relative;
`
